import styled from "styled-components";
export const CardContainer = styled.div`
  display: grid;

  gap: 16px;

  h3 {
    margin: 0;
    padding: 0;
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;
